// Get font switcher element
const fontSwitcher = document.getElementById('dyslexicSwitch');

// Set localstorage name
const dyslexicStateName = 'isDyslexic';

function getDyslexic() {
  // Get localstorage item
  const isDyslexic = window.localStorage.getItem(dyslexicStateName) === 'true';

  // Change state based on user preference
  if (isDyslexic) {
    document.documentElement.classList.add('is-dyslexic');
  } else {
    document.documentElement.classList.remove('is-dyslexic');
  }
}

function setDyslexic() {
  // Get localstorage item
  const isDyslexic = window.localStorage.getItem(dyslexicStateName) === 'true';

  // Set state based on preference
  if (isDyslexic) {
    window.localStorage.removeItem(dyslexicStateName);
  } else {
    window.localStorage.setItem(dyslexicStateName, 'true');
  }

  // Check and change the document state
  getDyslexic();
}

// Add click listener
fontSwitcher.addEventListener('click', setDyslexic);

// Check state on page load
getDyslexic();
